// extracted by mini-css-extract-plugin
export default {"wrapper":"QuestionMarkTooltip_wrapper__922b8","questionMark":"QuestionMarkTooltip_questionMark__tSI2b","tooltip":"QuestionMarkTooltip_tooltip__wbGrM"};